const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default initialState;
